import React from "react";

import { Container, Typography, Box, Button } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="md" sx={{ mt: 5, textAlign: "center" }}>
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" gutterBottom>
        Sorry, the page you are looking for does not exist. You can always go
        back to the homepage.
      </Typography>
      <Box sx={{ mt: 5 }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ mr: 2 }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to="/suites"
        >
          Go to Suites
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
